module.exports = __webpack_public_path__ + "static/img/1.a7013aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/1.png
// module id = tLr3
// module chunks = 0